import styled from 'styled-components';
import { ScrollSpy } from 'organism-react-scroll-nav';
import {
  MOBILE_NAV_HEIGHT,
  MOBILE_NAV_TRANSITION_FUNCTION,
  MOBILE_NAV_TRANSITION_SPEED,
} from 'common/consts/navigation';
import { media } from 'designsystem/index';
import ds from 'designsystem';

const StyledScrollSpy = styled(ScrollSpy)`
  position: relative;
  top: 0;
  transition: top ${MOBILE_NAV_TRANSITION_SPEED} ${MOBILE_NAV_TRANSITION_FUNCTION};
  
  ${({ mobileopen }) => (mobileopen === 'open' ? `
    top: ${MOBILE_NAV_HEIGHT};
  ` : '')};
  
  ${media.desktop`
    ${({ top }) => (top === 'top' ? `margin-top: ${ds.get('navSection.navHeight')}` : '')}
  `}
`;

export default StyledScrollSpy;



// WEBPACK FOOTER //
// ./src/blocks/PageContent/StyledScrollSpy.jsx